// extracted by mini-css-extract-plugin
export default {"card":"PO","cardrow":"QO","cardcentered":"RO","details":"SO","imgwrapper":"TO","img":"UO","category":"VO","name":"WO","copy":"XO","detailsbtn":"YO","remove":"ZO","price":"aP","netPrice":"bP","regularPrice":"cP","label":"eP"};
    if(module.hot) {
      // 1713969935620
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  